import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#3a3a3a] text-white">
      <div className="container-custom section-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/a85dcbccb159a60b1d34439ee45a35ad.png" 
              alt="altta talent studio" 
              className="h-16 mb-6"
            />
            <p className="text-sm leading-relaxed opacity-90 mb-6">
              Un estudio de talento femenino donde la elegancia contemporánea 
              y la autenticidad se convierten en herramientas de comunicación 
              para las marcas más exigentes.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium museo-font mb-6 text-white">
              Navegación
            </h4>
            <div className="space-y-3">
              <Link to="/" className="block text-sm opacity-90 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Inicio
              </Link>
              <Link to="/altta-community" className="block text-sm opacity-90 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Altta Community
              </Link>
              <Link to="/contacto" className="block text-sm opacity-90 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Contacto
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium museo-font mb-6 text-white">
              Contacto
            </h4>
            <div className="space-y-3 text-sm opacity-90">
              <p>Paseo de la Independencia 25</p>
              <p>50001 Zaragoza, España</p>
              <a href="mailto:contacto@alttatalentstudio.com" className="block hover:text-[#ffb7b4] transition-colors cursor-pointer">
                contacto@alttatalentstudio.com
              </a>
              <a href="tel:+34644221998" className="block hover:text-[#ffb7b4] transition-colors cursor-pointer">
                +34 644 221 998
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm opacity-75">
              © 2024 Altta Talent Studio. Todos los derechos reservados.
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/aviso-legal" className="text-sm opacity-75 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Aviso Legal
              </Link>
              <Link to="/politica-privacidad" className="text-sm opacity-75 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Privacidad
              </Link>
              <Link to="/politica-cookies" className="text-sm opacity-75 hover:opacity-100 hover:text-[#ffb7b4] transition-colors cursor-pointer">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
